import braintree from "braintree-web";

const paymentType = 'braintree:hostedField';

Alpine.data('SevenHostedFieldSet', (element) => ({
    name: element.dataset.name,
    threeDSecure: null,

    init() {
        const inputStyle = this._getInputStyle();
        const fields = this._getFields(inputStyle);

        element.addEventListener('seven:braintree:threedsecure:init', (e) => {
            this.threeDSecure = e.detail;
        });

        document.addEventListener("braintree:client:init", (event) => {
            const {client} = event.detail;
            const tokenType = `${paymentType}:${this.name}`;

            braintree.hostedFields.create(
                {
                    client,
                    fields,
                    preventAutofill: false,
                    styles: {input: inputStyle},
                },
                (error, instance) => {
                    if (error) {
                        this._dispatchEvent('error', {element, name: this.name, error});
                    } else {
                        this._dispatchEvent('init', {
                            tokenType,
                            name: this.name,
                            instance: instance,
                            tokenize: async () => {
                                const fields = Object.values(instance.getState().fields);
                                this._setValidityClass(fields);
                                const token = await instance.tokenize();

                                return {
                                    details: token.details,
                                    threeDSecure: this.threeDSecure,
                                    paymentToken: {
                                        ...token,
                                        type: tokenType,
                                    },
                                }
                            },
                            validate: async () => {
                                const fields = Object.values(instance.getState().fields);
                                this._setValidityClass(fields);
                            }
                        });
                    }

                    instance.on('validityChange', (event) => {
                        Object.values(event.fields)
                            .filter(field => field.isFocused)
                            .forEach(this._setValidityClass);
                    });

                    instance.on('inputSubmitRequest', (event) => this._setValidityClass(Object.values(event.fields)));
                    instance.on('blur', (event) => this._setValidityClass(event.fields[event.emittedBy]));
                }
            );
        });
    },

    _setValidityClass(fieldOrFields) {
        (Array.isArray(fieldOrFields) ? fieldOrFields : [fieldOrFields]).forEach((field) => {
            field.container.classList.toggle('is-valid', field.isValid);
            field.container.classList.toggle('is-invalid', !field.isValid);
        });
    },

    /*
     * Create a fake form-control to be able to get the styles from it.
     * After styles are computed, the fake input is removed.
     */
    _getInputStyle() {
        const fake = document.createElement("input");
        fake.classList.add("form-control");
        fake.classList.add("braintree-form-control");
        document.body.append(fake);

        const props = [
            "display",
            "width",
            "height",
            "padding",
            "font-size",
            "font-weight",
            "font-family",
            "line-height",
            "color",
            "-webkit-appearance",
            "-moz-appearance",
            "appearance",
            "background-color",
            "background-clip",
            "border",
            "border-radius",
            "transition"
        ];

        const style = window.getComputedStyle(fake);
        const inputStyle = Array.from(style)
            .filter((property) => props.includes(property))
            .reduce(
                (acc, property) => ({
                    ...acc,
                    fontFamily: style.getPropertyValue("font-family"),
                    [property]: style.getPropertyValue(property)
                }),
                {}
            );

        fake.remove();
        return inputStyle;
    },

    _getFields(inputStyle) {
        return [...element.querySelectorAll(".seven-braintree-hosted-field")].reduce((acc, wrapper) => {
            const field = wrapper.querySelector(".form-control");
            field.style.height = inputStyle.height;

            const {name, ...rest} = field.dataset ?? {};

            return {
                ...acc,
                [name.match(/\[(.*?)]/)[1]]: {
                    selector: `.form-control[data-name="${name}"]`,
                    ...rest,
                },
            };
        }, {});
    },

    _dispatchEvent(name, {cancelable, bubbles, ...detail} = {}) {
        return element.dispatchEvent(new CustomEvent(`seven:braintree:hostedfieldset:${name}`, {
            detail,
            bubbles: bubbles ?? true,
            cancelable: cancelable ?? true,
        }));
    }

}));


